// Слайдер главной страницы (_slider.html.twig) и замена превью на слайдер.
import { $ } from './lib/dollar';
import { createSlider } from './lib/slider';

export function installMainSlider(doc = document) {
    const win = doc.defaultView;
    $(doc).ready(() => {
        const sliders = Array.prototype.map.call(doc.querySelectorAll('.slider'), node => {
            createSlider(node, { autoplaySpeed: 20000 });
            return node;
        });
        // Превью меняется на слайдер после того, как картинка превью декодирована и показана хотя бы
        // в одном кадре: крупнейший элемент экрана (LCP) не ждёт ядра и слайдера. Картинка и размер
        // у превью и слайда одинаковые. Ошибка картинки меняет сразу, медленная загрузка — не позже
        // чем через 5 с: раньше у слайдера без картинки нет высоты, и страница прыгает.
        let swapped = false;
        const swap = () => {
            if (swapped) return;
            swapped = true;
            $('#slider-preview').hide();
            $('#slider-real').show();
            // Слайдер запущен на скрытом блоке: размеры пересчитываются сразу, до следующего кадра.
            sliders.forEach(node => node.sdSlider && node.sdSlider.setPosition());
        };
        const afterFrame = () => win.requestAnimationFrame(() => win.setTimeout(swap, 0));
        const preview = doc.querySelector('#slider-preview img');
        if (preview && typeof preview.decode === 'function') {
            preview.decode().then(afterFrame, swap);
            win.setTimeout(swap, 5000);
        } else {
            afterFrame();
        }
    });
}
